import { render } from "./PopupPanel.vue?vue&type=template&id=8a9a4b60"
import script from "./PopupPanel.vue?vue&type=script&lang=js"
export * from "./PopupPanel.vue?vue&type=script&lang=js"

import "./PopupPanel.vue?vue&type=style&index=0&id=8a9a4b60&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__